import { NavLink, Link, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, LogOut } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function PlannerLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900" data-testid="planner-layout">
      <header className="sticky top-0 z-40 bg-ink border-b border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/planner" className="flex items-center gap-2" data-testid="planner-logo">
            <span className="h-7 w-7 rounded-md bg-neon flex items-center justify-center font-display font-black text-ink text-xs">OX</span>
            <span className="font-display font-bold tracking-tight text-white">OrthoPlani<span className="text-neon">X</span>
              <span className="ml-2 text-[10px] font-body font-semibold uppercase tracking-widest text-slate-500">Planner Console</span>
            </span>
          </Link>
          <div className="flex items-center gap-4">
            <p className="hidden sm:block text-sm font-semibold text-slate-300" data-testid="planner-user-name">{user?.name}</p>
            <button onClick={handleLogout} data-testid="planner-logout-btn"
              className="inline-flex items-center gap-1.5 text-xs font-semibold text-slate-400 hover:text-red-400 transition-colors border border-white/15 rounded-full px-3.5 py-2">
              <LogOut className="h-3.5 w-3.5" /> Sign out
            </button>
          </div>
        </div>
      </header>

      <div className="max-w-[1400px] mx-auto px-6 py-8 grid lg:grid-cols-[220px_1fr] gap-8">
        <aside>
          <nav className="flex lg:flex-col gap-2">
            <NavLink to="/planner" end data-testid="planner-nav-queue"
              className={({ isActive }) => `inline-flex items-center gap-2.5 rounded-lg px-4 py-2.5 text-sm font-semibold transition-colors ${isActive ? "bg-sky-600 text-white" : "text-slate-600 hover:bg-white hover:text-slate-900"}`}>
              <LayoutDashboard className="h-4 w-4" /> My Queue
            </NavLink>
          </nav>
        </aside>
        <main className="min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
